import React from "react";
import { Card, Col, Row } from "antd";
import {
	ShoppingCartOutlined,
	RocketOutlined,
	WalletOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import "./style.css";

const formatCurrency = (n) =>
	`₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;

const StatCard = ({ title, value, icon, iconBg, onClick, subTitle }) => (
	<Col xs={24} sm={12} md={8} lg={8} xl={8} className="dashboard-stat-col">
		<Card
			className="dashboard-stat-card-compact"
			hoverable
			onClick={onClick}
		>
			<div className="dashboard-stat-card-compact-inner">
				<div className="dashboard-stat-card-compact-content">
					<div className="dashboard-stat-card-compact-title">{title}</div>
					<div className="dashboard-stat-card-compact-value">{value}</div>
					{subTitle != null && (
						<div className="dashboard-stat-card-compact-sub">{subTitle}</div>
					)}
				</div>
				<div
					className="dashboard-stat-card-compact-icon"
					style={{ backgroundColor: iconBg || "#1890ff" }}
				>
					{icon}
				</div>
			</div>
		</Card>
	</Col>
);

const NewDashboardCard = ({ information }) => {
	const navigate = useNavigate();
	const info = information || {};
	const go = (path) => () => path && navigate(path);
	const purchaseCount = info.purchase_count ?? 0;
	const saleCount = info.sale_count ?? 0;

	return (
		<div className="dashboard-cards-wrap dashboard-main-cards">
			<Row gutter={[12, 12]}>
				<StatCard
					title="Total Purchase"
					value={formatCurrency(info.purchase_total)}
					icon={<ShoppingCartOutlined />}
					iconBg="#1890ff"
					onClick={go("/purchaselist")}
					subTitle={`${purchaseCount} Invoice${purchaseCount !== 1 ? "s" : ""}`}
				/>
				<StatCard
					title="Total Sale"
					value={formatCurrency(info.sale_total)}
					icon={<RocketOutlined />}
					iconBg="#52c41a"
					onClick={go("/salelist")}
					subTitle={`${saleCount} Invoice${saleCount !== 1 ? "s" : ""}`}
				/>
				<StatCard
					title="Total Profit"
					value={formatCurrency(info.sale_profit)}
					icon={<WalletOutlined />}
					iconBg="#722ed1"
					onClick={go("/account/profit-and-loss")}
				/>
			</Row>
		</div>
	);
};

export default NewDashboardCard;
